import { render, staticRenderFns } from "./TotalSub.vue?vue&type=template&id=16b248e6&"
import script from "./TotalSub.vue?vue&type=script&lang=js&"
export * from "./TotalSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports